import React, { ReactElement } from "react";
import { ListTableColumn, Text, renderEnumValue } from "sprint-common-web";

import { AssetStatus } from "../types/AssetStatus";
import { AssetType } from "../types/AssetType";

export const renderAssetStatus = <T extends { assetType?: AssetType }>(
    item?: T,
    _index?: number,
    column?: ListTableColumn<T>
): ReactElement | null => {
    return <Text variant={"small"}>{renderEnumValue(AssetStatus, item, _index, column)}</Text>;
};
